import useVersionCheck from "../hooks/useVersionCheck.hook";

/**
 * Aviso flotante cuando hay una versión nueva deployada. Al tocar "Actualizar"
 * recarga la página para tomar el build nuevo. Recarga manual (no automática)
 * para no interrumpir al usuario en medio de un formulario.
 */
export default function UpdateBanner() {
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        left: "50%",
        bottom: "1rem",
        transform: "translateX(-50%)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        maxWidth: "92vw",
        padding: "0.7rem 1rem",
        borderRadius: "12px",
        background: "var(--primary-platform, #004b76)",
        color: "#fff",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        fontSize: "0.9rem",
      }}
    >
      <span>Hay una versión nueva disponible.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          border: "none",
          borderRadius: "8px",
          padding: "0.4em 0.9em",
          fontWeight: 700,
          cursor: "pointer",
          background: "#fff",
          color: "var(--primary-platform, #004b76)",
        }}
      >
        Actualizar
      </button>
    </div>
  );
}
